import ScheduleColumnManager from '../../schedules/ScheduleColumnManager';

export default class CarbonFreeColumnManager extends ScheduleColumnManager {
  addIntermediateColumns(columns) {
    super.addIntermediateColumns(columns);

    this.addColumn(columns, {
      alignment: 'left',
      allowEditing: false,
      allowFiltering: true,
      allowHiding: true,
      allowResizing: true,
      dataType: 'string',
      caption: 'Contract',
      dataField: 'contractDisplayName',
      visible: false,
      width: 80
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: true,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: false,
      allowResizing: false,
      dataType: 'boolean',
      caption: 'Carbon Free',
      dataField: 'isCarbonFree',
      showEditorAlways: true,
      visible: true,
      width: 100
    });
  }

  addTrailingColumns(columns) {
    super.addTrailingColumns(columns);

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Sum (Hours)',
      dataField: 'energySumH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 85
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Sum (MWh)',
      dataField: 'energySumMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: true,
      width: 85
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'CF Total (Hours)',
      dataField: 'carbonFreeTotalH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 80
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'CF Total (MWh)',
      dataField: 'carbonFreeTotalMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: true,
      width: 80
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'CF Pending (Hours)',
      dataField: 'carbonFreePendingH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 80
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'CF Pending (MWh)',
      dataField: 'carbonFreePendingMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 80
    });
  }

  getColumnCssClass() {
    return 'pwx-alert-overlay-none pwx-flag-none pwx-select-none pwx-state-normal pwx-highlight-none pwx-cell-standard';
  }
}